import { createStore } from "vuex";
import qs from "qs";

import getCompanies from "@component_path/lib/call_api/agent_selection/getCompanies";

import formData from "@component_path/agent_selection_wish_module/store/formData";
import masterData from "@component_path/agent_selection_wish_module/store/masterData";

const state = {
  inquiryFormPath: "",
  maxSelectCount: 0
};

const getters = {
  inquiryFormPath: state => lpType => {
    const query = {
      utf8: "✓",
      lp_type: lpType,
      agent_selection_wish: {
        prefecture_id: state.formData.prefecture_id,
        address: state.formData.address,
        position_type: state.formData.position_type,
        employment_type: state.formData.employment_type,
        agent_selection_auction_ids: state.formData.agent_selection_auction_ids
      }
    };
    return `${state.inquiryFormPath}?${qs.stringify(query, {
      arrayFormat: "brackets"
    })}`;
  },
  fetchingCompaniesParams: state => lpType => {
    const query = {
      utf8: "✓",
      lp_type: lpType,
      agent_selection_wish: {
        prefecture_id: state.formData.prefecture_id,
        address: state.formData.address,
        position_type: state.formData.position_type,
        employment_type: state.formData.employment_type
      }
    };

    return qs.stringify(query, { arrayFormat: "brackets" });
  },
  prefectureText(state) {
    const prefecture = state.masterData.prefectures.find(
      prefecture => prefecture.value === state.formData.prefecture_id
    );
    return prefecture ? prefecture.label : "";
  },
  cityText(state) {
    const city = state.masterData.cities.find(
      city => city.id == state.formData.city_id
    );
    return city ? city.label : "";
  },
  addressText(state) {
    const city = state.masterData.cities.find(
      city => city.value === state.formData.address
    );
    return city ? city.label : "";
  },
  employmentTypeText(state) {
    const employmentType = state.masterData.employmentTypes.find(
      employmentType => employmentType.value === state.formData.employment_type
    );
    return employmentType ? employmentType.label : "";
  },
  positionTypeText(state) {
    const positionType = state.masterData.positionTypes.find(
      positionType => positionType.value === state.formData.position_type
    );
    return positionType ? positionType.label : "";
  },
  wishfulTimeText(state) {
    const wishfulTime = state.masterData.wishfulTimes.find(
      wishfulTime => wishfulTime.value === state.formData.wishful_time
    );
    return wishfulTime ? wishfulTime.label : "";
  },
  ageText(state) {
    const age = state.masterData.birthYears.find(
      birth_year => birth_year.value === state.formData.age
    );
    return age ? age.label : "";
  }
};

const actions = {
  async fetchCompanies(
    { dispatch, getters, state },
    { lpType, defaultSelectCount }
  ) {
    dispatch("formData/setAgentSelectionAuctionIds", []);
    if (state.formData.prefecture_id) {
      const query = getters.fetchingCompaniesParams(lpType);
      const responseData = await getCompanies(query);
      dispatch("masterData/setAgentSelectionAuctions", responseData.companies);
      const defaultSelectedCompanies = responseData.companies
        .slice(0, defaultSelectCount)
        .map(company => company.id);
      dispatch(
        "formData/setAgentSelectionAuctionIds",
        defaultSelectedCompanies
      );
    } else {
      dispatch("masterData/setAgentSelectionAuctions", []);
    }
  },
  setInquiryFormPath({ commit }, path) {
    commit("SET_INQUIRY_FORM_PATH", path);
  },
  setMaxSelectCount({ commit }, count) {
    commit("SET_MAX_SELECT_COUNT", count);
  }
};

const mutations = {
  SET_INQUIRY_FORM_PATH(state, path) {
    state.inquiryFormPath = path;
  },
  SET_MAX_SELECT_COUNT(state, count) {
    state.maxSelectCount = count;
  }
};

export default createStore({
  state: () => state,
  getters,
  actions,
  mutations,
  modules: {
    formData,
    masterData
  }
});
